import { PatchBankAccountQueryParamsType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchBankAccount/patchBankAccountQuery.type';
import { MutationOptions } from '@tanstack/react-query';
import { patchBankAccountFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/patchBankAccount/patchBankAccountQueryFunction';
import { AxiosResponse } from 'axios';

export const patchBankAccountQueryOptions = (): MutationOptions<
  AxiosResponse<any, any>,
  Error,
  PatchBankAccountQueryParamsType
> => ({
  mutationKey: ['patch-Bank-Account'],
  mutationFn: (params: PatchBankAccountQueryParamsType) =>
    patchBankAccountFunction(params),
});
